import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import TitleHeaderComponent from '@/components/TitleHeader/TitleHeader.vue';
import { TitleHeader } from '@/common/interfaces/TitleHeader';

const TitleHeaderModuleProps = Vue.extend({
  props: getComponentProps<TitleHeader>({
    Title: 'The Expedition Team',
    Text:
      "Lindblad Expeditions are helmed by some of the world's foremost adventurers. Seasoned captains, naturalists, historians, divers and expedition leaders who'll take you closer to remarkable worlds.",
    Center: false,
  }),
});

@Component({
  components: {
    TitleHeaderComponent,
  },
})
export default class TitleHeaderModule extends TitleHeaderModuleProps {}
